export default interface IAuthService {
    getToken(): Promise<string | undefined>;
}

export const IAuthService_TYPE = Symbol.for('IAuthService');
